export const MAIN_CLASS_NAME = 'model-selector';
export const EXTRA_CLASS_NAME = `${MAIN_CLASS_NAME}__extra`;
export const EXTRA_ITEM_CLASS_NAME = `${EXTRA_CLASS_NAME}__item`;
export const MODAL_CLASS_NAME = `${MAIN_CLASS_NAME}__modal`;
export const MODAL_ROW_CLASS_NAME = `${MODAL_CLASS_NAME}__row`;
export const MODAL_ROW_ITEM_CLASS_NAME = `${MODAL_ROW_CLASS_NAME}__item`;

export const LLM_SETTINGS = {
  temperature: {
    minValue: 0,
    step: 0.1,
  },
  context_window: {
    minValue: 0,
    precision: 0,
  },
  max_tokens: {
    minValue: 0,
    precision: 0,
  },
  seed: {
    precision: 0,
  },
  top_k: {
    minValue: -1, // NOTE: Set to -1 to consider all tokens.
    precision: 0,
  },
  top_p: {
    minValue: 0,
    maxValue: 1,
    step: 0.01,
  },
  presence_penalty: {
    step: 0.1,
  },
};
